import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  InputSignalWithTransform
} from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-gift-card-preview',
  templateUrl: './gift-card-preview.component.html',
  styleUrl: './gift-card-preview.component.scss',
  imports: [CurrencyPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GiftCardPreviewComponent {
  recipientName: InputSignal<string> = input<string>('');
  senderName: InputSignal<string> = input<string>('');

  amount: InputSignal<number> = input<number>(0);
  message: InputSignal<string> = input<string>('');

  image: InputSignalWithTransform<string | null, File | null> = input(null, {
    transform: (value: File | null): string => {
      if (value) {
        return URL.createObjectURL(value);
      }

      return '';
    }
  });
}
